import { RootState } from "../store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import environment from "environment";
import { TokenService, UsernameService } from "../../services/LocalStorage";

import { MarketPlaceService } from "../../interfaces/MarketPlaceService";
import { MarketPlaceProduct } from "../../interfaces/MarketPlaceProduct";

import API from "../../services/API";

import { NavItemProps } from "react-minimal-side-navigation/lib";
import { MarketPlaceRequest } from "../../interfaces/MarketPlaceRequest";
import { RequestTemplate } from "../../interfaces/RequestTemplate";
import { RequestGuideTemplate } from "../../interfaces/RequestGuideTemplate";
import { FormAnswerPayload } from "../../interfaces/DynamicForms";
import {
  AssetInformation,
  CiInformationTable,
  ciSerial,
} from "../../interfaces/AssetInformation";

import { uploadFile } from "./RuleStore";
import { FlowRequestPayload } from "../../interfaces/FlowRequestPayload";
import i18n from "i18next";




interface MarketPlaceState {
  loading: boolean;
  showCi: boolean;
  showCiTable: boolean;
  requestCreated: boolean;
  requestCreationError: boolean;
  services: MarketPlaceService[];
  navbarServices: NavItemProps[];
  list: searchUser[];
  selectedProduct: MarketPlaceProduct | null;
  selectedServiceIndex: number;
  template: RequestTemplate | null;
  guideTemplate: RequestTemplate | null;
  requestCreatedId: number | null;
  isCallingServer: boolean;
  cisInformation: AssetInformation[];
  ciTableInformation: CiInformationTable[];
  ciSerialSelected: ciSerial[];
}

const notifyRequestCreation = (requestId: number): void => {
  const message: string = i18n.t("request_created_success", { id: requestId });
  // const message: string = `Solicitud No. ${requestId}  creada con éxito`;

  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: "create-reuqest-success",
  });
};
 


const initialState: MarketPlaceState = {
  loading: false,
  showCi: false,
  showCiTable: false,
  requestCreated: false,
  requestCreationError: false,
  services: [],
  list: [],
  navbarServices: [],
  selectedProduct: null,
  selectedServiceIndex: 0,
  template: null,
  guideTemplate: null,
  requestCreatedId: null,
  isCallingServer: false,
  cisInformation: [],
  ciTableInformation: [],
  ciSerialSelected: [],
};

export interface searchUser {
  fullName?: string;
  mail?: string;
  userLogin?: string;
}

export const MarketPlaceStore = createSlice({
  name: "MarketPlace",
  initialState,
  reducers: {
    setUsers: (state: any, action: PayloadAction<searchUser[]>) => {
      state.list = action.payload;
    },
    setLoading: (state: any, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setShowCiStore: (state: any, action: PayloadAction<boolean>) => {
      state.showCi = action.payload;
    },
    setShowCiTable: (state: any, action: PayloadAction<boolean>) => {
      state.showCiTable = action.payload;
    },
    setCISerialSelected: (state: any, action: PayloadAction<ciSerial[]>) => {
      state.ciSerialSelected = action.payload;
    },
    setCiTableInformation: (
      state: any,
      action: PayloadAction<CiInformationTable[]>
    ) => {
      state.ciTableInformation = action.payload;
    },
    setRequestCreationError: (state: any, action: PayloadAction<boolean>) => {
      state.requestCreationError = action.payload;
    },
    setRequestCreated: (state: any, action: PayloadAction<boolean>) => {
      state.requestCreated = action.payload;
    },
    setServices: (state: any, action: PayloadAction<MarketPlaceService[]>) => {
      state.services = action.payload;
    },
    setCisInformation: (
      state: any,
      action: PayloadAction<AssetInformation[]>
    ) => {
      state.cisInformation = action.payload;
    },
    setSelectedProduct: (
      state: any,
      action: PayloadAction<MarketPlaceProduct | null>
    ) => {
      state.selectedProduct = action.payload;
    },
    setSelectedServiceIndex: (state: any, action: PayloadAction<number>) => {
      state.serviceIndex = action.payload;
    },
    setRequestedId: (state: any, action: PayloadAction<number>) => {
      state.requestCreatedId = action.payload;
    },
    setNavbarServices: (state: any, action: PayloadAction<NavItemProps[]>) => {
      state.navbarServices = action.payload;
    },
    setTemplate: (state: any, action: PayloadAction<RequestTemplate>) => {
      state.template = action.payload;
    },
    setGuideTemplate: (
      state: any,
      action: PayloadAction<RequestGuideTemplate>
    ) => {
      state.guideTemplate = action.payload;
    },
    setIsCallingServer: (
      state: { isCallingServer: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.isCallingServer = action.payload;
    },
    cleanStore: () => {
      return { ...initialState };
    },
  },
});

export const createProductRequest =
  (productRequest: MarketPlaceRequest, formPaylodad?: FormAnswerPayload) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      dispatch(setRequestedId(0));
      dispatch(setIsCallingServer(true));

      productRequest = { ...productRequest, token: TokenService.get() };
      if (formPaylodad) {
        await API()
          .post("services/createrequest", productRequest)
          .then((response: any) => {
            if (response && response.data.Status === "Ok") {
              const requestId: number = response.data.Values.RequestID;
              
              formPaylodad.RegisterId = requestId;
              const userNameR : string | null = localStorage.getItem("userName") ;
              
              dispatch( uploadFileDinamicoP(requestId.toString(), productRequest.fileDinamico,userNameR ?? undefined));
              dispatch(uploadFile(requestId.toString(), productRequest.file));
              dispatch(createForm(formPaylodad));
              dispatch(setRequestedId(requestId));
              dispatch(setRequestCreated(true));
              notifyRequestCreation(requestId);
            } else {
              dispatch(setRequestCreationError(true));
            }

            dispatch(setLoading(false));
          })
          .catch((error: unknown) => {})
          .finally(() => {
            dispatch(setIsCallingServer(false));
          });
      } else {
        await API()
          .post("services/createrequest", productRequest)
          .then((response: any) => {
            if (response && response.data.Status === "Ok") {
              const requestId: number = response.data.Values.RequestID;
              const userNameR : string | null = localStorage.getItem("userName") ;
              dispatch( uploadFileDinamicoP(requestId.toString(), productRequest.fileDinamico,userNameR ?? undefined));
              dispatch(uploadFile(requestId.toString(), productRequest.file));
              notifyRequestCreation(requestId);
              dispatch(setRequestedId(requestId));
              dispatch(setRequestCreated(true));
            } else {
              dispatch(setRequestCreationError(true));
              dispatch(setRequestedId(0));
            }

            dispatch(setLoading(false));
          })
          .catch((error: unknown) => {})
          .finally(() => {
            dispatch(setIsCallingServer(false));
          });
      }
    } catch (error: unknown) {
      dispatch(setLoading(false));
      dispatch(setIsCallingServer(false));

      console.error("[MARKETPLACE] [ERROR] Error creating request: ", error);
    }
  };

export const createProductRequestFromRule =
  (
    productRequest: MarketPlaceRequest,
    formPaylodad?: FormAnswerPayload,
    ciSerial?: ciSerial[]
  ) =>
  async (dispatch: any) => {
    try {
      if (productRequest.ReglaID && productRequest.ReglaID < 1) return;

      dispatch(setLoading(true));
      dispatch(setRequestedId(0));
      dispatch(setIsCallingServer(true));

      productRequest = { ...productRequest, token: TokenService.get() };

      await API()
        .post("Rules/getRule", productRequest)
        .then(async (response: any) => {
          if (response && response.data.Status === "Ok") {
            const requestId: number = response.data.Values.RequestID;
            const userNameR : string | null = localStorage.getItem("userName") ;
            dispatch(uploadFileDinamicoP(requestId.toString(), productRequest.fileDinamico,userNameR ?? undefined));
            
            dispatch(uploadFile(requestId.toString(), productRequest.file));

            if (formPaylodad) {
              formPaylodad.RegisterId = requestId;
              dispatch(createForm(formPaylodad));
            }

            if (ciSerial && ciSerial.length > 0) {
              // console.log("recibimos los ci para asociar", ciSerial);

              await API()
                .post(`assets/AssociateCIToRequest`, {
                  token: TokenService.get(),
                  requestID: requestId,
                  ciList: ciSerial,
                })
                .then(() => {
                  dispatch(setCiTableInformation([]));
                });
            }

            notifyRequestCreation(requestId);
            dispatch(setRequestedId(requestId));
            dispatch(setRequestCreated(true));
          } else {
            dispatch(setRequestCreationError(true));
          }

          dispatch(setLoading(false));
        })
        .catch((error: any) => {
  const message = error?.response?.data?.Values?.Exception;

  if (message) {
    console.error(
            "[MARKETPLACE] [ERROR] Error creating request from rule",
            message
          );
    toast.error(
            `No se pudo crear la solicitud, revise las reglas o parametros de configuracion`,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          
  } else {
    toast.error(
            `No se pudo crear la solicitud, por favor comuníquese con el Administrador`,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
  }
          // if(response.data.Values.Exception){
           

          // }else{
           
          // }
          
        })
        .finally(() => {
          dispatch(setIsCallingServer(false));
        });
    } catch (error: unknown) {
      toast.error(`No se puede crear la solicitud sin una regla`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error(
        "[MARKETPLACE] [ERROR] Error creating request from rule",
        error
      );

      dispatch(setLoading(false));
      dispatch(setIsCallingServer(false));
    }
  };

export const createProductRequestFromTemplate =
  (
    productRequest: MarketPlaceRequest,
    formPaylodad?: FormAnswerPayload,
    ciSerial?: ciSerial[]
  ) =>
  async (dispatch: any) => {
    try {
      if (productRequest.TemplateID && productRequest.TemplateID < 1) return;

      dispatch(setLoading(true));
      dispatch(setRequestedId(0));
      dispatch(setIsCallingServer(true));

      productRequest = {
        ...productRequest,
        MarketPlaceRequest: true,
        token: TokenService.get(),
      };
      
      await API()
        .post("services/CreateRequestTemplate", productRequest)
        .then(async (response: any) => {
          if (response && response.data.Status === "Ok") {
            const requestId: number = response.data.Values.RequestID;
            const userNameR : string | null = localStorage.getItem("userName") ;
            dispatch(uploadFileDinamicoP(requestId.toString(), productRequest.fileDinamico,userNameR ?? undefined));
            dispatch(uploadFile(requestId.toString(), productRequest.file));

            if (formPaylodad) {
              formPaylodad.RegisterId = requestId;
              dispatch(createForm(formPaylodad));
            }

            if (ciSerial && ciSerial.length > 0) {
              // console.log(
              //   "recibimos los ci para asociar en template",
              //   ciSerial
              // );

              await API()
                .post(`assets/AssociateCIToRequest`, {
                  token: TokenService.get(),
                  requestID: requestId,
                  ciList: ciSerial,
                })
                .then(() => {
                  dispatch(setCiTableInformation([]));
                });
            }

            notifyRequestCreation(requestId);
            dispatch(setRequestedId(requestId));
            dispatch(setRequestCreated(true));
          } else {
            dispatch(setRequestCreationError(true));
          }

          dispatch(setLoading(false));
        })
        .catch(() => {})
        .finally(() => {
          dispatch(setIsCallingServer(false));
        });
    } catch (error: unknown) {
      dispatch(setLoading(false));
      console.error("[MARKETPLACE] [ERROR] Error creating request: ", error);
    }
  };

export const createProductRequestFromFlow =
  (
    productRequest: MarketPlaceRequest,
    formPaylodad?: FormAnswerPayload,
    ciSerial?: ciSerial[],
    subjectDescriptionEnable: boolean = false
  ) =>
  async (dispatch: any) => {
    try {
      productRequest = {
        ...productRequest,
        MarketPlaceRequest: true,
        token: TokenService.get(),
      };

      const { flowId } = productRequest;

      // console.log("🚀 ~ file: MarketPlaceStore.ts:312 ~ flowId:", flowId);
      await API()
        .get(
          `services/GetFlowById?token=${TokenService.get()}&flujoId=${flowId}`
        )
        .then(async (response: any) => {
          if (response?.data?.Status === "Ok") {
            const values = response.data.Value;

            if (values.length < 1) {
              dispatch(setRequestCreationError(true));
              return;
            }

            const result = values.at(0);

            const flowRequest = {
              ...result,
              onBehalfTo: productRequest.OnBehalfTo,
              startDate: productRequest.StartDate ?? "",
              throughOf : productRequest.ThroughOf ?? "301",
              token: TokenService.get(),
            };

            if (subjectDescriptionEnable) {
              flowRequest.requestTitle = productRequest.Subject;
              flowRequest.requestDescription = productRequest.Description;
            }

            await API()
              .post("flows/request", flowRequest)
              .then(async (response: any) => {
                if (response?.data?.Status !== "Ok") {
                  dispatch(setRequestCreationError(true));
                  return;
                }

                const requestId: number = response.data.Values.RequestID;

                if (ciSerial && ciSerial.length > 0) {
                  // console.log(
                  //   "recibimos los ci para asociar en template",
                  //   ciSerial
                  // );

                  await API()
                    .post(`assets/AssociateCIToRequest`, {
                      token: TokenService.get(),
                      requestID: requestId,
                      ciList: ciSerial,
                    })
                    .then(() => {
                      dispatch(setCiTableInformation([]));
                    });
                }
             
                const userNameR : string | null = localStorage.getItem("userName") ;
                dispatch( uploadFileDinamicoP(requestId.toString(), productRequest.fileDinamico,userNameR ?? undefined));
             
            
                  dispatch(uploadFile(requestId.toString(), productRequest.file));
                
               
                /* dispatch(uploadFile(requestId.toString(), productRequest.file)); */

                if (formPaylodad) {
                  formPaylodad.RegisterId = requestId;
                  dispatch(createForm(formPaylodad));
                }

                notifyRequestCreation(requestId);
                dispatch(setRequestedId(requestId));
                dispatch(setRequestCreated(true));
              })
              .catch((error: unknown) => {
                dispatch(setRequestCreationError(true));
              })
              .finally(() => {
                dispatch(setIsCallingServer(false));
              });
          } else {
            dispatch(setRequestCreationError(true));
          }
          dispatch(setLoading(false));
        })
        .catch((error: unknown) => {})
        .finally(() => {
          dispatch(setIsCallingServer(false));
        });
    } catch (error: unknown) {
      dispatch(setLoading(false));
      console.error("[MARKETPLACE] [ERROR] Error creating request: ", error);
    }
  };

export const createForm =
  (formPaylodad: FormAnswerPayload) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      await API()
        .post("/Formulario/SaveForm", formPaylodad)
        .then((response: any) => {
          if (response && response.data.Status !== "Ok")
            dispatch(setRequestCreationError(true));

          dispatch(setLoading(false));
        });
    } catch (error: unknown) {
      dispatch(setLoading(false));
      console.error("[MARKETPLACE] [ERROR] Error creating form: ", error);
    }
  };

  export const uploadFileDinamicoP =
  (requestID: string, files: any, user: string = "test") =>
  async (dispatch: any) => {
    const message: string = i18n.t("actives.success");
    const message2: string = i18n.t("actives.errro");
    // Filtrar solo las claves que tienen un array de archivos
    const camposAdjuntos = Object.keys(files || {}).filter(
      (key) => Array.isArray(files[key]) && files[key] !== null
    );

    for (const campo of camposAdjuntos) {
      const FormsFile = files[campo]; 
      const formData = new FormData();
      FormsFile.forEach((file: File) => {
        formData.append("files", file);
      });

      try {
        const token = localStorage.getItem("token")
        const response = await API().post(
          `/File/UploadResourceS3?s3Path=AdjuntoFormularioDinamico/${requestID}/${campo}`,
          formData,
          {
            headers: {
              "x-helppeople-useraction": user,
              "x-helppeople-registerid": requestID,
              "x-helppeople-token":token
            },
          }
        );
        if(response.data.RejectedFiles.length > 0){
          response.data.RejectedFiles.map((file:any) => {
            toast.error(`${message} ${file.FileName}: ${file.Error}`, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            })
          

        }
        if(response.data.status==='Exito al subir archivos'){
          toast.success(message, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "create-reuqest-success",
          });
        }else{
          toast.error(`${message2}`, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        
        }
        // const message: string = i18n.t("actives.success");
      
        
        console.log("Respuesta del servidor:", response.data);
      } catch (error) {
        toast.error(`${message2} ${error}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

export const uploadRequestFile =
  (files: File[], requestId: number, actionCode: number = 1) =>
  async () => {
    if (!files && files === null) return;

    const userLogin: string = UsernameService.get().username;

    let customHeaders = new Headers();
    customHeaders.set("x-helppeople-appcode", "5");
    customHeaders.set("x-helppeople-actioncode", actionCode.toString());
    customHeaders.set("x-helppeople-useraction", userLogin);
    customHeaders.set("x-helppeople-registerid", `${requestId}`);
    customHeaders.set("x-helppeople-token", TokenService.get());

    const formdata = new FormData();

    files.forEach((file) => {
      formdata.append("payload", file, file.name);
    });

    const uploadRequest: any = {
      method: "POST",
      body: formdata,
      headers: customHeaders,
      redirect: "follow",
    };

    const serviceURL: string = `${environment.api.url}/file/UploadResource`;

    try {
      fetch(serviceURL, uploadRequest).catch((error: unknown) =>
        console.error("Error uploading attachment", error)
      );
    } catch (error: unknown) {
      console.error("[MARKETPLACE] [ERROR] Error uploading product attachment");
    }
  };

export const getTemplate = (serviceId: number) => async (dispatch: any) => {
  try {
    await API()
      .get(
        `services/GetTemplateByServiceCode?token=${TokenService.get()}&serviceId=${serviceId}`
      )
      .then((response: any) => {
        if (response && response.data.Status === "Ok") {
          const template: RequestTemplate = {
            TemplateDescription: response.data.Value,
          };
          dispatch(setTemplate(template));
        }
      });
  } catch (error: unknown) {
    console.error("[MARKETPLACE] [ERROR] Error retrieving template: ", error);
  }
};

export const getCISAll =
  (ciidOrName: any, type: any, onbehalftoid: any) => async (dispatch: any) => {
    try {
      await API()
        .get(
          `/assets/GetAssetsByType?token=${TokenService.get()}&ciidOrName=${ciidOrName}&type=${type}&onbehalftoid=${onbehalftoid}`
        )
        .then((response: any) => {
          if (response && response.data.Status === "Ok") {
            dispatch(setCisInformation(response.data.Values));
          }
          // console.log(response, "response getCISAll");
          // console.log();
        });
    } catch (error) {
      console.error("[MARKETPLACE] [ERROR] Error CIS", error);
    }
  };

export const getGuideTemplate =
  (guideTemplateId: number) => async (dispatch: any) => {
    try {
      await API()
        .get(
          `services/GetGuideTemplate?token=${TokenService.get()}&templateID=${guideTemplateId}`
        )
        .then((response: any) => {
          if (response && response.data.Status === "Ok") {
            const guideTemplate: RequestGuideTemplate = {
              TemplateID: response.data.TemplateID,
              TemplateText: response.data.TemplateText,
            };
            dispatch(setGuideTemplate(guideTemplate));
          }
        });
    } catch (error: unknown) {
      console.error("[MARKETPLACE] [ERROR] Error retrieving guide: ", error);
    }
  };

export const getServices =
  (searchTerm: string = "") =>
  async (dispatch: any) => {
    try {
      await API()
        .get(
          `services/getservices?token=${TokenService.get()}&isMarketplaceRequest=true&searchedProduct=${searchTerm}`
        )
        .then(async (response: any) => {
          if (response && response.data.Status === "Ok") {
            let mappedServices: MarketPlaceService[] = [];
            let mappedProducts: MarketPlaceProduct[] = [];
            let mappedNavbarServices: NavItemProps[] = [];

            response.data.Values.forEach((responseService: any) => {
              responseService.Products.forEach(
                (responseProduct: MarketPlaceProduct) => {
                  mappedProducts.push(responseProduct);
                }
              );

              const marketPlaceService: MarketPlaceService = {
                serviceId: responseService.Value,
                serviceName: responseService.Text,
                products: mappedProducts,
              };

              const navbarService: NavItemProps = {
                itemId: marketPlaceService.serviceId.toString(),
                title: marketPlaceService.serviceName,
              };

              mappedServices.push(marketPlaceService);
              mappedNavbarServices.push(navbarService);
              mappedProducts = [];
            });

            dispatch(setServices(mappedServices));
            await dispatch(setNavbarServices(mappedNavbarServices));
          }
        });
    } catch (error: any) {
      return console.error(error.message);
    }
  };

export const getUsersBasic =
  (searchOnbehalfto: string) => async (dispatch: any) => {
    try {
      await API()
        .get(
          `users/getusersbasic?token=${TokenService.get()}&usernameOrNames=${searchOnbehalfto}`
        )
        .then(async (response) => {
          let data: searchUser[] = [];
          data = await Promise.all(
            response.data.Values.map(async (requestItem: any) => {
              let newUser: searchUser = {
                fullName: requestItem.FullName,
                mail: requestItem.Mail,
                userLogin: requestItem.Username,
              };
              return newUser;
            })
          );
          dispatch(setUsers(data));
        });
    } catch (error) {
      console.error(error);
    }
  };

export const {
  setUsers,
  setLoading,
  setRequestCreated,
  setRequestCreationError,
  setServices,
  setSelectedProduct,
  setSelectedServiceIndex,
  setNavbarServices,
  setTemplate,
  setGuideTemplate,
  setIsCallingServer,
  cleanStore,
  setRequestedId,
  setCisInformation,
  setCiTableInformation,
  setShowCiStore,
  setCISerialSelected,
  setShowCiTable,
} = MarketPlaceStore.actions;
export const marketPlace = (state: RootState) => state.marketPlace;
export default MarketPlaceStore.reducer;
